import {useWatch} from "react-hook-form";
import {FulfillmentType} from "@/data/entities/restaurant";
import {PosOrderForm} from "@/data/entities/order";

/**
 * Current fulfillment type of the order editor form, derived from the
 * delivery address.
 */
export const useFulfillmentType = (): FulfillmentType => {
    const type = useWatch<PosOrderForm, "deliveryAddress.type">({name: "deliveryAddress.type"});
    return type === "TAKEAWAY" ? "TAKEAWAY" : "DELIVERY";
};